import {
    ArrowRightOutlined,
    ArrowLeftOutlined,
    ExclamationCircleOutlined,
    DeleteOutlined,
    PaperClipOutlined,
} from '@ant-design/icons';
import { Form, Input, Button, Tooltip, Checkbox, Upload } from 'antd';
import { useState } from 'react';

import ModalFail from '../../../../components/Shared/modal/fail';

export default function Stap4(props) {
    const { TextArea } = Input;
    const { Dragger } = Upload;

    const [showAddon, setShowAddon] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [disbleUpload, setDisbleUpload] = useState(false);

    const [openFail, setOpenFail] = useState(false);
    const [msg, setMsg] = useState('');
    //Previous and Next
    const onNextStep = () => {
        props.nextStep();
    };
    const onPreviousStep = () => {
        props.previousStep();
    };

    const proofOfIdentity = [
        {
            id: '1',
            nameTH: (
                <>
                    กรณีสัญชาติไทย:
                    สำเนาบัตรประชาชนของเจ้าของข้อมูลส่วนบุคคลและ/หรือตัวแทน{' '}
                    <span>(โปรดลบข้อมูลศาสนาและหมู่โลหิตออกก่อนนำส่ง)</span>
                </>
            ),
            nameEN: 'Thai Nationality: A copy of Data Subject’s Identification card or Agent’s Identification card (Please erase or blackout your Religion and Blood Type data before sent to the company)',
        },
        {
            id: '2',
            nameTH: 'กรณีต่างชาติ สำเนาหนังสือเดินทางเจ้าของข้อมูลส่วนบุคคลและ/หรือตัวแทน ',
            nameEN: 'Foreign Nationality: A copy of Data Subject’s or Agent’s Passport (If any)',
        },
        {
            id: '3',
            nameTH: 'หนังสือมอบอำนาจ (กรณีผู้ขอเป็นตัวแทนของเจ้าของข้อมูลส่วนบุคคล) ',
            nameEN: 'Power of Attorney (In case of an Agent of a Data Subject) ',
        },
        {
            id: '4',
            nameTH: 'กรณีผู้เยาว์: สำเนาสูติบัตร หรือสำเนาทะเบียนบ้าน',
            nameEN: 'In the case of a minor: a copy of the birth certificate or a copy of the house registration',
        },
        {
            id: '5',
            nameTH: 'กรณีบุคคลไร้ความสามารถ หรือเสมือนไร้ความสามารถ: สำเนาหลักฐานการแต่งตั้งให้เป็นตัวแทนของเจ้าของข้อมูล',
            nameEN: 'In the case of an incompetent person Incompetent or quasi-incompetent: a copy of proof of designation as a representative of the data subject.',
        },
        {
            id: '6',
            nameTH: 'หลักฐานอื่นๆ',
            nameEN: 'Other evidence',
        },
    ];

    const allowedType = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/msword', // .doc
        'application/pdf', // .pdf
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel', // .xls
        'image/png', // .png
        'image/jpeg', // .jepg
    ];

    const checkFile = () => {
        if (fileList && fileList.length > 0) {
            return Promise.resolve();
        }

        return Promise.reject(new Error('This field is required.'));
    };

    return (
        <div
            className="rounded-md p-5 h-full"
            style={{
                backgroundColor: props?.customStyle?.bgColor, //bgColor
            }}
        >
            <div className="space-y-3">
                <div
                    className="text-xl font-bold text-[#7B67FB] px-3"
                    style={{
                        color: props?.fontStyle?.textCardColor,
                    }}
                >
                    4.{' '}
                    {props.lang === 'TH'
                        ? 'หลักฐานหรือข้อมูลให้เพียงพอต่อการดำเนินการ'
                        : 'Sufficient evidence or information for the operation'}
                </div>
                <div style={{ border: '1px solid #DBDBDB' }}></div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    className="px-3"
                    name="step4"
                    form={props.form}
                    layout="vertical"
                >
                    <div
                        className="font-bold text-xl"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                        }}
                    >
                        {props.lang === 'TH'
                            ? 'หลักฐานการยืนยันตัวตน'
                            : 'Proof of identity'}
                    </div>
                    <div
                        className="font-semibold pb-1 pt-2"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                            fontSize: props?.fontStyle?.fontSize,
                        }}
                    >
                        {props.lang === 'TH'
                            ? 'หลักฐานการยืนยันตัวตน'
                            : 'Proof of identity'}
                        <span
                            className="ml-1.5 pb-1 text-[#ff4d4f] font-medium text-sm lead-[1px]"
                            style={{ fontFamily: 'SimSun, sans-serif' }}
                        >
                            *
                        </span>
                    </div>
                    <Form.Item
                        noStyle={showAddon}
                        style={{ margin: '0 0 24px' }}
                        name={'proofOfIdentity'}
                        // label={
                        //     <>
                        //         <div
                        //             className="font-semibold"
                        //             style={{
                        //                 color: props?.fontStyle
                        //                     ?.textCardColor,
                        //                 fontSize:
                        //                     props?.fontStyle?.fontSize,
                        //             }}
                        //         >
                        //             หลักฐานการยืนยันตัวตน
                        //         </div>
                        //     </>
                        // }
                        rules={[
                            {
                                required: true,
                                message:
                                    props.lang === 'TH'
                                        ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                        : 'This field is required.',
                            },
                        ]}
                    >
                        <Checkbox.Group
                            onChange={() => {
                                if (
                                    props.form
                                        .getFieldsValue()
                                        .proofOfIdentity?.includes('6')
                                ) {
                                    setShowAddon(true);
                                } else {
                                    setShowAddon(false);
                                }
                            }}
                            className="w-full space-y-2"
                        >
                            {proofOfIdentity?.map((item) => (
                                <div key={item?.id}>
                                    <Checkbox
                                        style={{
                                            color: props?.fontStyle
                                                ?.textCardColor,
                                            fontSize:
                                                props?.fontStyle?.fontSize,
                                        }}
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {props.lang === 'EN'
                                            ? item?.nameEN
                                            : item?.nameTH}
                                    </Checkbox>
                                </div>
                            ))}
                        </Checkbox.Group>
                    </Form.Item>

                    {showAddon && (
                        <Form.Item
                            className="pt-3"
                            name={'proofOfIdentityAddon'}
                            rules={[
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <TextArea
                                size="large"
                                className="w-5/6"
                                maxLength={60}
                                autoSize={{ minRows: 1 }}
                                placeholder={
                                    props.lang === 'TH'
                                        ? 'โปรดระบุ'
                                        : 'Please specify'
                                }
                            ></TextArea>
                        </Form.Item>
                    )}

                    {props?.customForm?.display?.evidence && (
                        <>
                            <div className="flex items-center space-x-2  pb-3">
                                <div
                                    className="font-bold text-xl"
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                    }}
                                >
                                    {props.lang === 'TH'
                                        ? 'หลักฐานประกอบคำขอใช้สิทธิ'
                                        : 'Supporting Document'}
                                </div>
                                <div>
                                    <Tooltip
                                        placement="right"
                                        overlayClassName="min-w-[30%]"
                                        title={
                                            <>
                                                {props.lang === 'TH'
                                                    ? 'เอกสารหรือหลักฐานเพิ่มเติมในการประกอบคำขอใช้สิทธิ เช่น หนังสือสัญญา , หนังสือการให้ความยินยอม ฯลฯ'
                                                    : 'Documents or additional evidence in support of the request for exercise of rights, such as Contract, letter of consent, etc.'}
                                            </>
                                        }
                                    >
                                        <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                            <ExclamationCircleOutlined />
                                        </a>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="pb-3">
                                <Checkbox
                                    checked={disbleUpload}
                                    onChange={(e) => {
                                        setDisbleUpload(e.target.checked);
                                        props.form.resetFields(['file']);
                                    }}
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                >
                                    {props.lang === 'TH'
                                        ? 'หลักฐานประกอบคำขอใช้สิทธิ'
                                        : 'Supporting Document'}
                                </Checkbox>
                            </div>
                            {disbleUpload && (
                                <div className="w-max">
                                    <Form.Item
                                        name="file"
                                        rules={
                                            !disbleUpload
                                                ? false
                                                : [
                                                      {
                                                          required: true,
                                                          message:
                                                              props.lang ===
                                                              'TH'
                                                                  ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                                                  : 'This field is required.',
                                                          validator: checkFile,
                                                      },
                                                  ]
                                        }
                                    >
                                        <Dragger
                                            className="px-6"
                                            name="file"
                                            multiple={true}
                                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                            fileList={[]}
                                            disabled={!disbleUpload}
                                            onPreview={false}
                                            onChange={(info) => {
                                                for (
                                                    let i = 0;
                                                    i < info.fileList.length;
                                                    i++
                                                ) {
                                                    const fileSize =
                                                        info.fileList[i].size /
                                                        1024 /
                                                        1024;
                                                    const fileType =
                                                        info.fileList[i].type;
                                                    if (fileSize >= 2) {
                                                        console.log(
                                                            'file size error'
                                                        );
                                                        setMsg(
                                                            'Upload error file size is wrong.'
                                                        );
                                                        setOpenFail(true);
                                                        return;
                                                    }
                                                    if (
                                                        !allowedType.includes(
                                                            fileType
                                                        )
                                                    ) {
                                                        console.log(
                                                            'file type error'
                                                        );
                                                        // message.error('Allowed file type:  .xlsx');
                                                        setMsg(
                                                            'Upload error file type is wrong.'
                                                        );
                                                        setOpenFail(true);
                                                        return;
                                                    }
                                                }
                                                let listFile = [...fileList];
                                                for (
                                                    let i = 0;
                                                    i < info.fileList.length;
                                                    i++
                                                ) {
                                                    listFile.push(
                                                        info.fileList[i]
                                                    );
                                                }
                                                setFileList([...listFile]);
                                                props.form.setFieldsValue({
                                                    file: listFile,
                                                });
                                                if (listFile?.length <= 0) {
                                                    props.form.setFields([
                                                        {
                                                            name: 'file',
                                                            errors: [
                                                                'This field is required.',
                                                            ],
                                                        },
                                                    ]);
                                                } else {
                                                }
                                            }}
                                            onError={(err) => {
                                                console.log('onError', err);
                                            }}
                                            customRequest={async ({ file }) => {
                                                let fileList = new FormData();
                                                fileList.append('image', file);
                                                fileList.append(
                                                    'fileName',
                                                    file.name
                                                );
                                                fileList.append(
                                                    'action',
                                                    'image-create-application'
                                                );
                                            }}
                                        >
                                            <p>
                                                <svg
                                                    width="41"
                                                    height="32"
                                                    viewBox="0 0 41 32"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M20.5024 0C17.2425 0.00879434 14.0938 1.02029 11.6251 2.85175C9.73307 4.25425 8.36221 6.08175 8.00899 7.91562C3.86924 8.70187 0.742188 11.8044 0.742188 15.5507C0.742188 19.9028 4.96099 23.375 10.0813 23.375H19.2674V12.1274L13.9667 16.6898C13.7348 16.8893 13.4203 17.0013 13.0923 17.0013C12.7643 17.0013 12.4498 16.8893 12.2179 16.6898C11.986 16.4902 11.8557 16.2196 11.8557 15.9375C11.8557 15.6554 11.986 15.3848 12.2179 15.1852L19.628 8.81025C19.7427 8.7113 19.879 8.6328 20.029 8.57924C20.1791 8.52567 20.3399 8.4981 20.5024 8.4981C20.6648 8.4981 20.8257 8.52567 20.9757 8.57924C21.1257 8.6328 21.262 8.7113 21.3768 8.81025L28.7868 15.1852C29.0187 15.3848 29.149 15.6554 29.149 15.9375C29.149 16.2196 29.0187 16.4902 28.7868 16.6898C28.5549 16.8893 28.2404 17.0013 27.9124 17.0013C27.5845 17.0013 27.2699 16.8893 27.038 16.6898L21.7374 12.1274V23.375H32.0818C36.5625 23.375 40.2625 20.3363 40.2625 16.5176C40.2625 13.0411 37.1948 10.2085 33.2625 9.73038C32.6623 4.24788 27.1467 0 20.5024 0ZM19.2674 30.8125V23.375H21.7374V30.8125C21.7374 31.0943 21.6073 31.3645 21.3757 31.5638C21.144 31.7631 20.8299 31.875 20.5024 31.875C20.1748 31.875 19.8607 31.7631 19.6291 31.5638C19.3975 31.3645 19.2674 31.0943 19.2674 30.8125Z"
                                                        fill="#C4C4C4"
                                                    />
                                                </svg>
                                            </p>
                                            <p className="ant-upload-text">
                                                Drop file here, paste or{' '}
                                                <span className="text-[#7B67FB]">
                                                    browse file
                                                </span>{' '}
                                            </p>
                                            <p className="text-10 font-light">
                                                {props.lang === 'TH' ? (
                                                    <span>
                                                        สามารถอัปโหลดไฟล์สูงสุด
                                                        10 ไฟล์, ขนาดสูงสุด 2
                                                        MB.
                                                        <br />{' '}
                                                        (ประเภทไฟล์ที่อนุญาต :
                                                        .jpg, .jpeg, .png,
                                                        .docx, .xlsx, .pdf)
                                                    </span>
                                                ) : (
                                                    <span>
                                                        *Can upload 10 files,
                                                        max size of 2 MB.
                                                        <br /> (Allowed file
                                                        types : .jpg, .jpeg,
                                                        .png, .docx, .xlsx,
                                                        .pdf)
                                                    </span>
                                                )}
                                            </p>
                                        </Dragger>
                                    </Form.Item>
                                    {fileList?.map((file, i) => {
                                        return (
                                            <div className="flex justify-between">
                                                <div
                                                    key={i}
                                                    className="text-new space-x-2 cursor-pointer"
                                                    // onClick={() => downloadDoc(file)}
                                                >
                                                    <PaperClipOutlined />
                                                    <span className="decoration-2">
                                                        {file.name}
                                                    </span>
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        setFileList(
                                                            fileList.filter(
                                                                (data, key) =>
                                                                    key !== i
                                                            )
                                                        );
                                                    }}
                                                    className="text-[#95A0A8] cursor-pointer"
                                                >
                                                    <DeleteOutlined />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </>
                    )}

                    <div className="flex space-x-4 py-4">
                        <Button
                            // className="text-[#7B67FB] border-[#7B67FB]"
                            style={{
                                borderColor: props?.customStyle?.buttonColor,
                                color: props?.customStyle?.buttonColor,
                            }}
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                            className="w-[120px]"
                        >
                            <ArrowLeftOutlined />{' '}
                            {props.lang === 'TH' ? 'ย้อนกลับ' : 'Previous'}
                        </Button>
                        <Button
                            type="primary"
                            style={{
                                backgroundColor:
                                    props?.customStyle?.buttonColor,
                                color: props?.fontStyle?.textButtonColor,
                                borderColor: props?.customStyle?.buttonColor,
                            }}
                            size="large"
                            onClick={() => {
                                onNextStep();
                            }}
                            className="w-[120px]"
                        >
                            {props.lang === 'TH' ? 'ถัดไป' : 'Next'}{' '}
                            <ArrowRightOutlined />
                        </Button>
                    </div>
                </Form>
            </div>
            <ModalFail
                open={openFail}
                text={msg}
                handelClose={() => setOpenFail(false)}
            />
        </div>
    );
}
